module.exports = __webpack_public_path__ + "static/media/mp2.9b67b78c.jpeg";